import React from "react";
import "./TakTillGolvAbout.css";
import TakTillGolvAboutLogo from "../../../assets/TTGLogoBlack.png";

function TakTillGolvAbout() {
  return (
    <div className="Tak-Till-Golv-about-container">
      <div className="Tak-Till-Golv-about-content">
        <a
          href="https://taktillgolv.se/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="Tak-Till-Golv-about-logo-container">
            <img
              src={TakTillGolvAboutLogo}
              alt="TakTillGolvAboutLogo"
              className="Tak-Till-Golv-about-logo"
            />
          </div>
        </a>

        <div className="Tak-Till-Golv-about-text-container">
          <h1 className="Tak-Till-Golv-about-main-title">TakTillGolv.se</h1>
          <p className="Tak-Till-Golv-about-descriptions">
            At TakTillGolv.se, construction isn't just a trade – it's our craft.
            With a keen eye for detail and a passion for precision, every
            project we undertake is a testament to our dedication to excellence.
            <br />
            <br />
            From architectural design to the final touches, each step of the
            process is guided by our commitment to delivering exceptional
            results. Our expertise in both construction and architecture ensures
            a seamless experience, where your vision becomes a stunning reality.
            <br />
            <br />
            From concept to completion, our team works tirelessly to ensure
            every detail is perfect, every line is precise. With expertise in
            both construction and architecture, we offer a seamless experience,
            delivering projects that exceed expectations.
            <br />
            <br />
            At TakTillGolv.se, your project isn't just another job – it's a
            masterpiece in the making. With us, your dream space is not only
            possible but guaranteed."
          </p>
        </div>
      </div>
    </div>
  );
}

export default TakTillGolvAbout;
